// True khi web được nhúng trong app native (WebView) qua `?native=1`.
// Dùng để ẩn header/bottom-nav của web vì app đã có thanh riêng.
export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('native') === '1';
  } catch {
    return false;
  }
}
